import _ from 'lodash'
import { MAX_ALLOWED_PINS } from '../constants/map'
import { isMobile } from './osDetector'

export const getMaxResultsAllowed = (featureFlags = {}) => {
  const maxAllowed = featureFlags['fe.resi.search.max-results']
  if (!maxAllowed || _.isEmpty(maxAllowed)) return MAX_ALLOWED_PINS

  return isMobile()
    ? maxAllowed.mobile ?? MAX_ALLOWED_PINS
    : maxAllowed.desktop ?? MAX_ALLOWED_PINS
}
